module.exports = __webpack_public_path__ + "static/img/104.617268c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210407/104.jpg
// module id = Z6K0
// module chunks = 0